module.exports = __webpack_public_path__ + "static/media/settings.efd99106.png";